export default __webpack_public_path__ + "./img-course.8d16dd9f603c2716c9d8d24ce608239f.jpg";